import { Button } from 'shared/ui/Button'
import cls from './HeaderCollection.module.scss'
import { Text, TextColor, TextSize, TextWeight } from 'shared/ui/Text/Text'
import { classNames } from 'shared/lib/classNames/classNames'
import { BackIcon } from 'shared/ui/Icon'
import React from 'react'

const HeaderCollection = (props) => {
    const {
        onSwitchBack,
        header,
        counterWant,
        counterAccept,
        counter,
        className,
        fixed,
        titleClassName,
    } = props

    const count =
        counter ?? (header === 'Достигнуто' ? counterAccept : counterWant)

    const mods = {
        [cls.Fixed]: fixed,
    }

    return (
        <div className={classNames(cls.Container, mods, [className])}>
            <Button onClick={onSwitchBack} className={cls.CloseTextButton}>
                <BackIcon />
            </Button>
            <div className={classNames(cls.Header, {}, [titleClassName])}>
                {header}
            </div>
            <Text
                className={cls.Counter}
                weight={TextWeight.BOLD}
                size={TextSize.L}
                color={TextColor.TERBLACK}
            >
                {count}
            </Text>
        </div>
    )
}

export default HeaderCollection
